/*
 * quote-cart.js
 * Separate browser-side "cart" for quote products (apparel + accessories).
 * Boots use Shopify's real cart / checkout and never touch this.
 * Data lives in localStorage so it survives navigation ("keep shopping").
 */
(function () {
  if (window.QuoteCart) return; // safe against being included more than once

  var KEY = 'rowan_quote_cart_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('quote-cart:change', { detail: { items: items } }));
  }

  var QuoteCart = {
    all: function () { return read(); },

    count: function () {
      return read().reduce(function (n, i) { return n + (Number(i.quantity) || 0); }, 0);
    },

    add: function (item) {
      var items = read();
      var existing = items.filter(function (i) { return i.variantId === item.variantId; })[0];
      if (existing) {
        existing.quantity = (Number(existing.quantity) || 0) + (Number(item.quantity) || 1);
      } else {
        items.push(item);
      }
      write(items);
    },

    updateQty: function (variantId, quantity) {
      var items = read();
      var it = items.filter(function (i) { return i.variantId === variantId; })[0];
      if (!it) return;
      it.quantity = Number(quantity) || 0;
      if (it.quantity <= 0) {
        write(items.filter(function (i) { return i.variantId !== variantId; }));
      } else {
        write(items);
      }
    },

    remove: function (variantId) {
      write(read().filter(function (i) { return i.variantId !== variantId; }));
    },

    clear: function () { write([]); }
  };

  window.QuoteCart = QuoteCart;

  // Keep the count badges + floating tab in sync everywhere.
  function refresh() {
    var count = QuoteCart.count();
    document.querySelectorAll('[data-quote-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-quote-tab]').forEach(function (el) {
      el.style.display = count > 0 ? 'block' : 'none';
    });
  }

  document.addEventListener('quote-cart:change', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
})();